module.exports = __webpack_public_path__ + "img/12_COVER_PDN_byGlenfordNunez.0eab5892.0eab5892.jpg";